'use client';

/**
 * This file was automatically generated by the Stencil React Output Target.
 * Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
 */

/* eslint-disable */

import type { EventName, StencilReactComponent } from '@stencil/react-output-target/runtime';
import { createComponent } from '@stencil/react-output-target/runtime';
import React from 'react';

import { type ZprAccordionPanelCustomEvent, type ZprClipboardInputCustomEvent, type ZprDropdownCustomEvent, type ZprDropdownMenuCustomEvent, type ZprLabelCustomEvent, type ZprModalConfirmCustomEvent, type ZprModalCustomEvent, type ZprModalMultistepCustomEvent, type ZprModalSplitCustomEvent, type ZprProgressTabCustomEvent, type ZprProgressTabPanelCustomEvent, type ZprRadioItemCustomEvent, type ZprRadioListCustomEvent, type ZprSelectCustomEvent, type ZprSelectOptionCustomEvent, type ZprSelectWithFilterCustomEvent, type ZprSwitcherButtonCustomEvent, type ZprTabCustomEvent, type ZprTabsCustomEvent, type ZprToggleCustomEvent, type ZprToggleItemCustomEvent, type ZprTooltipCustomEvent } from "@zappar/zpr-ui-components-stencil";
import type { Components } from "@zappar/zpr-ui-components-stencil/dist/components";
import { ZprAccordionPanel as ZprAccordionPanelElement, defineCustomElement as defineZprAccordionPanel } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-accordion-panel.js";
import { ZprAccordion as ZprAccordionElement, defineCustomElement as defineZprAccordion } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-accordion.js";
import { ZprAlert as ZprAlertElement, defineCustomElement as defineZprAlert } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-alert.js";
import { ZprClipboardInput as ZprClipboardInputElement, defineCustomElement as defineZprClipboardInput } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-clipboard-input.js";
import { ZprDropdownMenu as ZprDropdownMenuElement, defineCustomElement as defineZprDropdownMenu } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-dropdown-menu.js";
import { ZprDropdown as ZprDropdownElement, defineCustomElement as defineZprDropdown } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-dropdown.js";
import { ZprLabel as ZprLabelElement, defineCustomElement as defineZprLabel } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-label.js";
import { ZprModalConfirm as ZprModalConfirmElement, defineCustomElement as defineZprModalConfirm } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-modal-confirm.js";
import { ZprModalMultistep as ZprModalMultistepElement, defineCustomElement as defineZprModalMultistep } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-modal-multistep.js";
import { ZprModalSplit as ZprModalSplitElement, defineCustomElement as defineZprModalSplit } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-modal-split.js";
import { ZprModalStep as ZprModalStepElement, defineCustomElement as defineZprModalStep } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-modal-step.js";
import { ZprModal as ZprModalElement, defineCustomElement as defineZprModal } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-modal.js";
import { ZprProgressRing as ZprProgressRingElement, defineCustomElement as defineZprProgressRing } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-progress-ring.js";
import { ZprProgressTabPanel as ZprProgressTabPanelElement, defineCustomElement as defineZprProgressTabPanel } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-progress-tab-panel.js";
import { ZprProgressTab as ZprProgressTabElement, defineCustomElement as defineZprProgressTab } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-progress-tab.js";
import { ZprProgressTabs as ZprProgressTabsElement, defineCustomElement as defineZprProgressTabs } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-progress-tabs.js";
import { ZprRadioItem as ZprRadioItemElement, defineCustomElement as defineZprRadioItem } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-radio-item.js";
import { ZprRadioList as ZprRadioListElement, defineCustomElement as defineZprRadioList } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-radio-list.js";
import { ZprSelectOptionGroup as ZprSelectOptionGroupElement, defineCustomElement as defineZprSelectOptionGroup } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-select-option-group.js";
import { ZprSelectOption as ZprSelectOptionElement, defineCustomElement as defineZprSelectOption } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-select-option.js";
import { ZprSelectWithFilter as ZprSelectWithFilterElement, defineCustomElement as defineZprSelectWithFilter } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-select-with-filter.js";
import { ZprSelect as ZprSelectElement, defineCustomElement as defineZprSelect } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-select.js";
import { ZprSwitcherButtonItem as ZprSwitcherButtonItemElement, defineCustomElement as defineZprSwitcherButtonItem } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-switcher-button-item.js";
import { ZprSwitcherButton as ZprSwitcherButtonElement, defineCustomElement as defineZprSwitcherButton } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-switcher-button.js";
import { ZprTab as ZprTabElement, defineCustomElement as defineZprTab } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-tab.js";
import { ZprTabsVertical as ZprTabsVerticalElement, defineCustomElement as defineZprTabsVertical } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-tabs-vertical.js";
import { ZprTabs as ZprTabsElement, defineCustomElement as defineZprTabs } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-tabs.js";
import { ZprToast as ZprToastElement, defineCustomElement as defineZprToast } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-toast.js";
import { ZprToasts as ZprToastsElement, defineCustomElement as defineZprToasts } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-toasts.js";
import { ZprToggleItem as ZprToggleItemElement, defineCustomElement as defineZprToggleItem } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-toggle-item.js";
import { ZprToggle as ZprToggleElement, defineCustomElement as defineZprToggle } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-toggle.js";
import { ZprTooltip as ZprTooltipElement, defineCustomElement as defineZprTooltip } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-tooltip.js";

export type ZprAccordionEvents = NonNullable<unknown>;

export const ZprAccordion: StencilReactComponent<ZprAccordionElement, ZprAccordionEvents, Components.ZprAccordion> = /*@__PURE__*/ createComponent<ZprAccordionElement, ZprAccordionEvents, Components.ZprAccordion>({
    tagName: 'zpr-accordion',
    elementClass: ZprAccordionElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprAccordionEvents,
    defineCustomElement: defineZprAccordion
});

export type ZprAccordionPanelEvents = { onPanelOpened: EventName<ZprAccordionPanelCustomEvent<any>> };

export const ZprAccordionPanel: StencilReactComponent<ZprAccordionPanelElement, ZprAccordionPanelEvents, Components.ZprAccordionPanel> = /*@__PURE__*/ createComponent<ZprAccordionPanelElement, ZprAccordionPanelEvents, Components.ZprAccordionPanel>({
    tagName: 'zpr-accordion-panel',
    elementClass: ZprAccordionPanelElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onPanelOpened: 'panelOpened' } as ZprAccordionPanelEvents,
    defineCustomElement: defineZprAccordionPanel
});

export type ZprAlertEvents = NonNullable<unknown>;

export const ZprAlert: StencilReactComponent<ZprAlertElement, ZprAlertEvents, Components.ZprAlert> = /*@__PURE__*/ createComponent<ZprAlertElement, ZprAlertEvents, Components.ZprAlert>({
    tagName: 'zpr-alert',
    elementClass: ZprAlertElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprAlertEvents,
    defineCustomElement: defineZprAlert
});

export type ZprClipboardInputEvents = { onCopied: EventName<ZprClipboardInputCustomEvent<any>> };

export const ZprClipboardInput: StencilReactComponent<ZprClipboardInputElement, ZprClipboardInputEvents, Components.ZprClipboardInput> = /*@__PURE__*/ createComponent<ZprClipboardInputElement, ZprClipboardInputEvents, Components.ZprClipboardInput>({
    tagName: 'zpr-clipboard-input',
    elementClass: ZprClipboardInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onCopied: 'copied' } as ZprClipboardInputEvents,
    defineCustomElement: defineZprClipboardInput
});

export type ZprDropdownEvents = { onDropdownOpen: EventName<ZprDropdownCustomEvent<boolean>> };

export const ZprDropdown: StencilReactComponent<ZprDropdownElement, ZprDropdownEvents, Components.ZprDropdown> = /*@__PURE__*/ createComponent<ZprDropdownElement, ZprDropdownEvents, Components.ZprDropdown>({
    tagName: 'zpr-dropdown',
    elementClass: ZprDropdownElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onDropdownOpen: 'dropdown-open' } as ZprDropdownEvents,
    defineCustomElement: defineZprDropdown
});

export type ZprDropdownMenuEvents = { onOpenChanged: EventName<ZprDropdownMenuCustomEvent<boolean>> };

export const ZprDropdownMenu: StencilReactComponent<ZprDropdownMenuElement, ZprDropdownMenuEvents, Components.ZprDropdownMenu> = /*@__PURE__*/ createComponent<ZprDropdownMenuElement, ZprDropdownMenuEvents, Components.ZprDropdownMenu>({
    tagName: 'zpr-dropdown-menu',
    elementClass: ZprDropdownMenuElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onOpenChanged: 'openChanged' } as ZprDropdownMenuEvents,
    defineCustomElement: defineZprDropdownMenu
});

export type ZprLabelEvents = { onLabelRemove: EventName<ZprLabelCustomEvent<string>> };

export const ZprLabel: StencilReactComponent<ZprLabelElement, ZprLabelEvents, Components.ZprLabel> = /*@__PURE__*/ createComponent<ZprLabelElement, ZprLabelEvents, Components.ZprLabel>({
    tagName: 'zpr-label',
    elementClass: ZprLabelElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onLabelRemove: 'label-remove' } as ZprLabelEvents,
    defineCustomElement: defineZprLabel
});

export type ZprModalEvents = {
    onClosed: EventName<ZprModalCustomEvent<any>>,
    onOpened: EventName<ZprModalCustomEvent<any>>
};

export const ZprModal: StencilReactComponent<ZprModalElement, ZprModalEvents, Components.ZprModal> = /*@__PURE__*/ createComponent<ZprModalElement, ZprModalEvents, Components.ZprModal>({
    tagName: 'zpr-modal',
    elementClass: ZprModalElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onClosed: 'closed',
        onOpened: 'opened'
    } as ZprModalEvents,
    defineCustomElement: defineZprModal
});

export type ZprModalConfirmEvents = {
    onConfirmed: EventName<ZprModalConfirmCustomEvent<any>>,
    onRejected: EventName<ZprModalConfirmCustomEvent<any>>
};

export const ZprModalConfirm: StencilReactComponent<ZprModalConfirmElement, ZprModalConfirmEvents, Components.ZprModalConfirm> = /*@__PURE__*/ createComponent<ZprModalConfirmElement, ZprModalConfirmEvents, Components.ZprModalConfirm>({
    tagName: 'zpr-modal-confirm',
    elementClass: ZprModalConfirmElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onConfirmed: 'confirmed',
        onRejected: 'rejected'
    } as ZprModalConfirmEvents,
    defineCustomElement: defineZprModalConfirm
});

export type ZprModalMultistepEvents = {
    onOpened: EventName<ZprModalMultistepCustomEvent<any>>,
    onClosed: EventName<ZprModalMultistepCustomEvent<any>>,
    onModalStepChanged: EventName<ZprModalMultistepCustomEvent<string>>
};

export const ZprModalMultistep: StencilReactComponent<ZprModalMultistepElement, ZprModalMultistepEvents, Components.ZprModalMultistep> = /*@__PURE__*/ createComponent<ZprModalMultistepElement, ZprModalMultistepEvents, Components.ZprModalMultistep>({
    tagName: 'zpr-modal-multistep',
    elementClass: ZprModalMultistepElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onOpened: 'opened',
        onClosed: 'closed',
        onModalStepChanged: 'modal-step-changed'
    } as ZprModalMultistepEvents,
    defineCustomElement: defineZprModalMultistep
});

export type ZprModalSplitEvents = {
    onClosed: EventName<ZprModalSplitCustomEvent<any>>,
    onOpened: EventName<ZprModalSplitCustomEvent<any>>
};

export const ZprModalSplit: StencilReactComponent<ZprModalSplitElement, ZprModalSplitEvents, Components.ZprModalSplit> = /*@__PURE__*/ createComponent<ZprModalSplitElement, ZprModalSplitEvents, Components.ZprModalSplit>({
    tagName: 'zpr-modal-split',
    elementClass: ZprModalSplitElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onClosed: 'closed',
        onOpened: 'opened'
    } as ZprModalSplitEvents,
    defineCustomElement: defineZprModalSplit
});

export type ZprModalStepEvents = NonNullable<unknown>;

export const ZprModalStep: StencilReactComponent<ZprModalStepElement, ZprModalStepEvents, Components.ZprModalStep> = /*@__PURE__*/ createComponent<ZprModalStepElement, ZprModalStepEvents, Components.ZprModalStep>({
    tagName: 'zpr-modal-step',
    elementClass: ZprModalStepElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprModalStepEvents,
    defineCustomElement: defineZprModalStep
});

export type ZprProgressRingEvents = NonNullable<unknown>;

export const ZprProgressRing: StencilReactComponent<ZprProgressRingElement, ZprProgressRingEvents, Components.ZprProgressRing> = /*@__PURE__*/ createComponent<ZprProgressRingElement, ZprProgressRingEvents, Components.ZprProgressRing>({
    tagName: 'zpr-progress-ring',
    elementClass: ZprProgressRingElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprProgressRingEvents,
    defineCustomElement: defineZprProgressRing
});

export type ZprProgressTabEvents = { onTabChanged: EventName<ZprProgressTabCustomEvent<any>> };

export const ZprProgressTab: StencilReactComponent<ZprProgressTabElement, ZprProgressTabEvents, Components.ZprProgressTab> = /*@__PURE__*/ createComponent<ZprProgressTabElement, ZprProgressTabEvents, Components.ZprProgressTab>({
    tagName: 'zpr-progress-tab',
    elementClass: ZprProgressTabElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onTabChanged: 'tabChanged' } as ZprProgressTabEvents,
    defineCustomElement: defineZprProgressTab
});

export type ZprProgressTabPanelEvents = {
    onVideoPlayed: EventName<ZprProgressTabPanelCustomEvent<any>>,
    onVideoEnded: EventName<ZprProgressTabPanelCustomEvent<any>>
};

export const ZprProgressTabPanel: StencilReactComponent<ZprProgressTabPanelElement, ZprProgressTabPanelEvents, Components.ZprProgressTabPanel> = /*@__PURE__*/ createComponent<ZprProgressTabPanelElement, ZprProgressTabPanelEvents, Components.ZprProgressTabPanel>({
    tagName: 'zpr-progress-tab-panel',
    elementClass: ZprProgressTabPanelElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onVideoPlayed: 'videoPlayed',
        onVideoEnded: 'videoEnded'
    } as ZprProgressTabPanelEvents,
    defineCustomElement: defineZprProgressTabPanel
});

export type ZprProgressTabsEvents = NonNullable<unknown>;

export const ZprProgressTabs: StencilReactComponent<ZprProgressTabsElement, ZprProgressTabsEvents, Components.ZprProgressTabs> = /*@__PURE__*/ createComponent<ZprProgressTabsElement, ZprProgressTabsEvents, Components.ZprProgressTabs>({
    tagName: 'zpr-progress-tabs',
    elementClass: ZprProgressTabsElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprProgressTabsEvents,
    defineCustomElement: defineZprProgressTabs
});

export type ZprRadioItemEvents = { onSelected: EventName<ZprRadioItemCustomEvent<any>> };

export const ZprRadioItem: StencilReactComponent<ZprRadioItemElement, ZprRadioItemEvents, Components.ZprRadioItem> = /*@__PURE__*/ createComponent<ZprRadioItemElement, ZprRadioItemEvents, Components.ZprRadioItem>({
    tagName: 'zpr-radio-item',
    elementClass: ZprRadioItemElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onSelected: 'selected' } as ZprRadioItemEvents,
    defineCustomElement: defineZprRadioItem
});

export type ZprRadioListEvents = { onChanged: EventName<ZprRadioListCustomEvent<any>> };

export const ZprRadioList: StencilReactComponent<ZprRadioListElement, ZprRadioListEvents, Components.ZprRadioList> = /*@__PURE__*/ createComponent<ZprRadioListElement, ZprRadioListEvents, Components.ZprRadioList>({
    tagName: 'zpr-radio-list',
    elementClass: ZprRadioListElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onChanged: 'changed' } as ZprRadioListEvents,
    defineCustomElement: defineZprRadioList
});

export type ZprSelectEvents = { onSelectChanged: EventName<ZprSelectCustomEvent<{ value: string, label: string }>> };

export const ZprSelect: StencilReactComponent<ZprSelectElement, ZprSelectEvents, Components.ZprSelect> = /*@__PURE__*/ createComponent<ZprSelectElement, ZprSelectEvents, Components.ZprSelect>({
    tagName: 'zpr-select',
    elementClass: ZprSelectElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onSelectChanged: 'select-changed' } as ZprSelectEvents,
    defineCustomElement: defineZprSelect
});

export type ZprSelectOptionEvents = { onOptionSelect: EventName<ZprSelectOptionCustomEvent<{ value: string, label: string }>> };

export const ZprSelectOption: StencilReactComponent<ZprSelectOptionElement, ZprSelectOptionEvents, Components.ZprSelectOption> = /*@__PURE__*/ createComponent<ZprSelectOptionElement, ZprSelectOptionEvents, Components.ZprSelectOption>({
    tagName: 'zpr-select-option',
    elementClass: ZprSelectOptionElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onOptionSelect: 'option-select' } as ZprSelectOptionEvents,
    defineCustomElement: defineZprSelectOption
});

export type ZprSelectOptionGroupEvents = NonNullable<unknown>;

export const ZprSelectOptionGroup: StencilReactComponent<ZprSelectOptionGroupElement, ZprSelectOptionGroupEvents, Components.ZprSelectOptionGroup> = /*@__PURE__*/ createComponent<ZprSelectOptionGroupElement, ZprSelectOptionGroupEvents, Components.ZprSelectOptionGroup>({
    tagName: 'zpr-select-option-group',
    elementClass: ZprSelectOptionGroupElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprSelectOptionGroupEvents,
    defineCustomElement: defineZprSelectOptionGroup
});

export type ZprSelectWithFilterEvents = { onChanged: EventName<ZprSelectWithFilterCustomEvent<string>> };

export const ZprSelectWithFilter: StencilReactComponent<ZprSelectWithFilterElement, ZprSelectWithFilterEvents, Components.ZprSelectWithFilter> = /*@__PURE__*/ createComponent<ZprSelectWithFilterElement, ZprSelectWithFilterEvents, Components.ZprSelectWithFilter>({
    tagName: 'zpr-select-with-filter',
    elementClass: ZprSelectWithFilterElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onChanged: 'changed' } as ZprSelectWithFilterEvents,
    defineCustomElement: defineZprSelectWithFilter
});

export type ZprSwitcherButtonEvents = {
    onChanged: EventName<ZprSwitcherButtonCustomEvent<any>>,
    onSwitcherChange: EventName<ZprSwitcherButtonCustomEvent<any>>
};

export const ZprSwitcherButton: StencilReactComponent<ZprSwitcherButtonElement, ZprSwitcherButtonEvents, Components.ZprSwitcherButton> = /*@__PURE__*/ createComponent<ZprSwitcherButtonElement, ZprSwitcherButtonEvents, Components.ZprSwitcherButton>({
    tagName: 'zpr-switcher-button',
    elementClass: ZprSwitcherButtonElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onChanged: 'changed',
        onSwitcherChange: 'switcherChange'
    } as ZprSwitcherButtonEvents,
    defineCustomElement: defineZprSwitcherButton
});

export type ZprSwitcherButtonItemEvents = NonNullable<unknown>;

export const ZprSwitcherButtonItem: StencilReactComponent<ZprSwitcherButtonItemElement, ZprSwitcherButtonItemEvents, Components.ZprSwitcherButtonItem> = /*@__PURE__*/ createComponent<ZprSwitcherButtonItemElement, ZprSwitcherButtonItemEvents, Components.ZprSwitcherButtonItem>({
    tagName: 'zpr-switcher-button-item',
    elementClass: ZprSwitcherButtonItemElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprSwitcherButtonItemEvents,
    defineCustomElement: defineZprSwitcherButtonItem
});

export type ZprTabEvents = { onTabChange: EventName<ZprTabCustomEvent<any>> };

export const ZprTab: StencilReactComponent<ZprTabElement, ZprTabEvents, Components.ZprTab> = /*@__PURE__*/ createComponent<ZprTabElement, ZprTabEvents, Components.ZprTab>({
    tagName: 'zpr-tab',
    elementClass: ZprTabElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onTabChange: 'tabChange' } as ZprTabEvents,
    defineCustomElement: defineZprTab
});

export type ZprTabsEvents = { onTabsChange: EventName<ZprTabsCustomEvent<any>> };

export const ZprTabs: StencilReactComponent<ZprTabsElement, ZprTabsEvents, Components.ZprTabs> = /*@__PURE__*/ createComponent<ZprTabsElement, ZprTabsEvents, Components.ZprTabs>({
    tagName: 'zpr-tabs',
    elementClass: ZprTabsElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onTabsChange: 'tabs-change' } as ZprTabsEvents,
    defineCustomElement: defineZprTabs
});

export type ZprTabsVerticalEvents = NonNullable<unknown>;

export const ZprTabsVertical: StencilReactComponent<ZprTabsVerticalElement, ZprTabsVerticalEvents, Components.ZprTabsVertical> = /*@__PURE__*/ createComponent<ZprTabsVerticalElement, ZprTabsVerticalEvents, Components.ZprTabsVertical>({
    tagName: 'zpr-tabs-vertical',
    elementClass: ZprTabsVerticalElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprTabsVerticalEvents,
    defineCustomElement: defineZprTabsVertical
});

export type ZprToastEvents = NonNullable<unknown>;

export const ZprToast: StencilReactComponent<ZprToastElement, ZprToastEvents, Components.ZprToast> = /*@__PURE__*/ createComponent<ZprToastElement, ZprToastEvents, Components.ZprToast>({
    tagName: 'zpr-toast',
    elementClass: ZprToastElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprToastEvents,
    defineCustomElement: defineZprToast
});

export type ZprToastsEvents = NonNullable<unknown>;

export const ZprToasts: StencilReactComponent<ZprToastsElement, ZprToastsEvents, Components.ZprToasts> = /*@__PURE__*/ createComponent<ZprToastsElement, ZprToastsEvents, Components.ZprToasts>({
    tagName: 'zpr-toasts',
    elementClass: ZprToastsElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprToastsEvents,
    defineCustomElement: defineZprToasts
});

export type ZprToggleEvents = { onChanged: EventName<ZprToggleCustomEvent<any>> };

export const ZprToggle: StencilReactComponent<ZprToggleElement, ZprToggleEvents, Components.ZprToggle> = /*@__PURE__*/ createComponent<ZprToggleElement, ZprToggleEvents, Components.ZprToggle>({
    tagName: 'zpr-toggle',
    elementClass: ZprToggleElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onChanged: 'changed' } as ZprToggleEvents,
    defineCustomElement: defineZprToggle
});

export type ZprToggleItemEvents = { onSelected: EventName<ZprToggleItemCustomEvent<any>> };

export const ZprToggleItem: StencilReactComponent<ZprToggleItemElement, ZprToggleItemEvents, Components.ZprToggleItem> = /*@__PURE__*/ createComponent<ZprToggleItemElement, ZprToggleItemEvents, Components.ZprToggleItem>({
    tagName: 'zpr-toggle-item',
    elementClass: ZprToggleItemElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onSelected: 'selected' } as ZprToggleItemEvents,
    defineCustomElement: defineZprToggleItem
});

export type ZprTooltipEvents = { onTooltipOpen: EventName<ZprTooltipCustomEvent<any>> };

export const ZprTooltip: StencilReactComponent<ZprTooltipElement, ZprTooltipEvents, Components.ZprTooltip> = /*@__PURE__*/ createComponent<ZprTooltipElement, ZprTooltipEvents, Components.ZprTooltip>({
    tagName: 'zpr-tooltip',
    elementClass: ZprTooltipElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onTooltipOpen: 'tooltip-open' } as ZprTooltipEvents,
    defineCustomElement: defineZprTooltip
});
